import { Link } from "react-router-dom";

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  icon,
}: {
  title: string;
  subtitle?: string;
  moreTo?: string;
  icon?: string;
}) {
  return (
    <div className="flex items-end justify-between mb-5">
      <div>
        <h2 className="flex items-center gap-2 text-xl md:text-2xl text-foreground-950">
          {icon && <i className={`${icon} text-primary-500 text-2xl`}></i>}
          {title}
        </h2>
        {subtitle && <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}